import {Component, OnDestroy} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {WizardFormEventsService} from '../../services/wizard-form-groups-services/wizard-form-events.service';

@Component({
    selector: 'wizard-result-fields',
    templateUrl: './wizard-result.component.html'
})
export class WizardResultFiledsComponent extends AbstractFields implements OnDestroy {
    constructor(
        public wizardFormEventsService: WizardFormEventsService,
    ) {
        super();
    }
}
